var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 143,
    height: 28,
    role: "img",
    "aria-label": "TAILWIND CSS",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TAILWIND CSS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 28,
    fill: "#38b2ac"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 100
  }, /*#__PURE__*/React.createElement("image", {
    x: 9,
    y: 7,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPlRhaWx3aW5kIENTUzwvdGl0bGU+PHBhdGggZD0iTTEyLjAwMSw0LjhjLTMuMiwwLTUuMiwxLjYtNiw0LjhjMS4yLTEuNiwyLjYtMi4yLDQuMi0xLjhjMC45MTMsMC4yMjgsMS41NjUsMC44OSwyLjI4OCwxLjYyNCBDMTMuNjY2LDEwLjYxOCwxNS4wMjcsMTIsMTguMDAxLDEyYzMuMiwwLDUuMi0xLjYsNi00LjhjLTEuMiwxLjYtMi42LDIuMi00LjIsMS44Yy0wLjkxMy0wLjIyOC0xLjU2NS0wLjg5LTIuMjg4LTEuNjI0IEMxNi4zMzcsNi4xODIsMTQuOTc2LDQuOCwxMi4wMDEsNC44eiBNNi4wMDEsMTJjLTMuMiwwLTUuMiwxLjYtNiw0LjhjMS4yLTEuNiwyLjYtMi4yLDQuMi0xLjhjMC45MTMsMC4yMjgsMS41NjUsMC44OSwyLjI4OCwxLjYyNCBjMS4xNzcsMS4xOTQsMi41MzgsMi41NzYsNS41MTIsMi41NzZjMy4yLDAsNS4yLTEuNiw2LTQuOGMtMS4yLDEuNi0yLjYsMi4yLTQuMiwxLjhjLTAuOTEzLTAuMjI4LTEuNTY1LTAuODktMi4yODgtMS42MjQgQzEwLjMzNywxMy4zODIsOC45NzYsMTIsNi4wMDEsMTJ6Ii8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.1)",
    x: 815,
    y: 175,
    textLength: 990,
    fill: "#fff",
    fontWeight: "bold"
  }, "TAILWIND CSS"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.3df132c481fe1bf5bc8211987960dca5.svg";
export { ForwardRef as ReactComponent };